export const PERIODS_1 = [
  {
    value: 'all',
    label: '누적'
  },
  {
    value: 'm3',
    label: '3M'
  },
  {
    value: 'y1',
    label: '1년'
  },
  {
    value: 'y3',
    label: '3년'
  }
]

export const PERIODS_2 = [
  {
    value: 'D',
    label: 'Daily'
  },
  {
    value: 'W',
    label: 'Weekly'
  },
  {
    value: 'M',
    label: 'Monthly'
  }
]

export const PERIODS_3 = [
  {
    value: '2000',
    label: '2000년 이후'
  },
  {
    value: '2010',
    label: '2010년 이후'
  },
  {
    value: '2020',
    label: '2020년 이후'
  }
]

export const PERIODS_4 = [
  {
    value: 'w',
    label: 'Weekly'
  },
  {
    value: 'm',
    label: 'Monthly'
  }
]

export const ASSETS = [
  {
    value: 'STOCK',
    label: '주식',
    index: 'KOSPI',
    inverse: false,
  },
  {
    value: 'BOND',
    label: '채권',
    index: '미국채 10년물',
    inverse: true,
  },
  {
    value: 'COMMODITY',
    label: '상품',
    index: 'KOSPI',
    inverse: false,
  },
  {
    value: 'FOREX',
    label: '외환',
    index: '원/달러',
    inverse: true
  },
  {
    value: 'VIX',
    label: '변동성',
    index: 'KOSPI',
    inverse: false
  },
  {
    value: 'BTC',
    label: '가상자산',
    index: '비트코인',
    inverse: false
  }
]

export const SCORES = [
  {
    value: 'G',
    label: '성장'
  },
  {
    value: 'V',
    label: '가치'
  },
  {
    value: 'M',
    label: '모멘텀'
  },
  {
    value: 'S',
    label: '안정성'
  },
  {
    value: 'P',
    label: '성과'
  }
]

export const CATEGORIES = [
  {
    value: 'trend',
    label: '달리는 말(추세)',
    info: '시장을 이기는 포트폴리오에서 인공지능이 선별한 종목'
  },
  {
    value: 'turnAround',
    label: '턴어라운드(역발상)',
    info: '현재 부진하나, 잠재적인 주가상승 기대감을 갖는 종목'
  },
  {
    value: 'mijung',
    label: '친절한미정씨',
    info: '한경유레카에서 서비스하고 있는 추천 종목'
  }
]

export const GURU_GREAT = {
  "벤자민 그레이엄": {
    name: "벤자민 그레이엄",
    info: "가치투자 아버지",
    img: "/static/images/protfolio_invest1.png"
  },
  "워렌 버핏": {
    name: "워렌 버핏",
    info: "복리 투자 마술사",
    img: "/static/images/protfolio_invest2.png"
  },
  "존 템플턴": {
    name: "존 템플턴",
    info: "역발상 가치투자",
    img: "/static/images/protfolio_invest3.png"
  },
  "피터 린치": {
    name: "피터 린치",
    info: "성장주 집중 투자 ",
    img: "/static/images/protfolio_invest4.png"
  },
  "필립 피셔": {
    name: "필립 피셔",
    info: "중소형 성장주 ",
    img: "/static/images/protfolio_invest5.png"
  },
  "토마스 로우 프라이드 Jr": {
    name: "토마스 로우\n프라이스 Jr",
    info: "성장투자 아버지 ",
    img: "/static/images/protfolio_invest6.png"
  },
  "존 네프": {
    name: "존 네프",
    info: "역발상 가치투자 ",
    img: "/static/images/protfolio_invest7.png"
  },
  "데이비드 드레만": {
    name: "데이비드 드레만",
    info: "역발상 투자 대가 ",
    img: "/static/images/protfolio_invest8.png"
  },
  "조엘 그린브라트": {
    name: "조엘 그린브라트",
    info: "마법공식 가치투자 ",
    img: "/static/images/protfolio_invest9.png"
  },
  "윌리엄 오닐": {
    name: "윌리엄 오닐",
    info: "CANSLIM 법칙 ",
    img: "/static/images/protfolio_invest10.png"
  }
}

export const MBTI_GREAT = {
  "분석가": {
    name: "분석가",
    info1: "직관형(N)과 사고형(T) 성격 유형",
    info2: "합리성, 공평성, 지적 우수성",
  },
  "이상주의자": {
    name: "이상주의자",
    info1: "직관형(N)과 감정형(F) 성격 유형",
    info2: "공감, 열정적인 이상주의",
  },
  "현실주의자": {
    name: "현실주의자",
    info1: "관찰형(S)과 판단형(J) 성격 유형",
    info2: "실용성, 안정성, 질서, 보안",
  },
  "탐험가": {
    name: "탐험가",
    info1: "관찰형(S)과 전망형(P) 성격 유형",
    info2: "자발성, 독창성, 유연성 중점",
  },
}

export const TA_GREAT = {
  "T": {
    name: "후천적",
  },
  "A": {
    name: "선천적",
  },
}

export const CONTENTS_CATEGORIES = {
  strategy: '오늘의 투자전략',
  pension: '퇴직/개인연금',
  service: '서비스 이용안내'
}

export const STOCK_ETF_RANKING_TAB_MENU = [
  {
    value: 'marketCap',
    label: '시가총액'
  },
  {
    value: 'upRate',
    label: '상승률'
  },
  {
    value: 'downRate',
    label: '하락률'
  }
]

export const STOCK_RANKING_CATEASSET_MENU = [
  {
    value: '',
    label: '전체'
  },
  {
    value: '건강관리',
    label: '건강관리'
  },
  {
    value: '자동차',
    label: '자동차'
  },
  {
    value: '화장품,의류,완구',
    label: '화장품,의류,완구'
  },
  {
    value: '화학',
    label: '화학'
  },
  {
    value: '필수소비재',
    label: '필수소비재'
  },
  {
    value: '운송',
    label: '운송'
  },
  {
    value: '상사,자본재',
    label: '상사,자본재'
  },
  {
    value: '비철,목재등',
    label: '비철,목재등'
  },
  {
    value: '건설,건축관련',
    label: '건설,건축관련'
  },
  {
    value: '보험',
    label: '보험'
  },
  {
    value: '에너지',
    label: '에너지'
  },
  {
    value: '기계',
    label: '기계'
  },
  {
    value: '철강',
    label: '철강'
  },
  {
    value: '반도체',
    label: '반도체'
  },
  {
    value: 'IT하드웨어',
    label: 'IT하드웨어'
  },
  {
    value: '소매(유통)',
    label: '소매(유통)'
  },
  {
    value: '증권',
    label: '증권'
  },
  {
    value: '디스플레이',
    label: '디스플레이'
  },
  {
    value: 'IT/가전',
    label: 'IT/가전'
  },
  {
    value: '유틸리티',
    label: '유틸리티'
  },
  {
    value: '미디어,교육',
    label: '미디어,교육'
  },
  {
    value: '은행',
    label: '은행'
  },
  {
    value: '통신서비스',
    label: '통신서비스'
  },
  {
    value: '호텔,레저서비스',
    label: '호텔,레저서비스'
  },
  {
    value: '소프트웨어',
    label: '소프트웨어'
  },
  {
    value: '조선',
    label: '조선'
  }
]

export const ETF_RANKING_CATEASSET_MENU = [
  {
    value: '',
    label: '전체'
  },
  {
    value: '지수',
    label: '지수'
  },
  {
    value: '섹터',
    label: '섹터'
  },
  {
    value: '테마',
    label: '테마'
  },
  {
    value: '배당',
    label: '배당'
  },
  {
    value: '채권',
    label: '채권'
  },
  {
    value: '상품',
    label: '상품'
  },
  {
    value: '리츠',
    label: '리츠'
  },
  {
    value: '예금',
    label: '예금'
  }
]

export const FINANCIAL_STATEMENTS_MENU = [
  {
    value: 'SALES',
    label: '매출액'
  },
  {
    value: 'OP',
    label: '영업이익'
  },
  {
    value: 'DEBT',
    label: '순부채',
    title1: '순부채 (십억원)'
  },
  {
    value: 'NP',
    label: '이익률'
  }
]

export const FINANCIAL_STATEMENTS_GUBN = {
  'SALES': {
    value: 'SALES',
    label: '매출액',
    title1: '매출액 (십억원)',
    title2: '전년동기대비 증감률 (%)'
  },
  'OP': {
    value: 'OP',
    label: '영업이익',
    title1: '영업이익 (십억원)',
    title2: '전년동기대비 증감률 (%)'
  },
  'DEBT': {
    value: 'DEBT',
    label: '순부채',
    title1: '순부채 (십억원)',
    title2: '부채비율 (%)'
  },
  'NP': {
    value: 'NP',
    label: '이익률',
    title1: '순이익률 (%)',
    title2: '영업이익률 (%)'
  }
}

export const PROMISING_ASSETS_MENU = [
  {
    value: 'RLTV01',
    label: '자산',
    plus: '위험자산',
    minus: '안전자산'
  },
  {
    value: 'RLTV05',
    label: '시장',
    plus: '이머징',
    minus: '선진국'
  },
  {
    value: 'RLTV02',
    label: '유형',
    plus: '성장주',
    minus: '가치주'
  },
  {
    value: 'RLTV04',
    label: '산업',
    plus: '첨단산업',
    minus: '전통산업'
  },
  {
    value: 'RLTV03',
    label: '대상',
    plus: '중소형주',
    minus: '대형주'
  }
]

export const PROMISING_ASSETS_GUBN = {
  'RLTV01': {
    value: 'RLTV01',
    label: '자산',
    plus: '위험자산',
    minus: '안전자산',
    plus_info: '은 주식, 상품 등의 자산을 의미합니다.',
    minus_info: '은 예금, 채권 등의 자산을 의미합니다.'
  },
  'RLTV05': {
    value: 'RLTV05',
    label: '시장',
    plus: '이머징',
    minus: '선진국',
    plus_info: '은 중국, 브라질 등의 국가를 의미합니다.',
    minus_info: '은 미국, 일본 등의 국가를 의미합니다.'
  },
  'RLTV02': {
    value: 'RLTV02',
    label: '유형',
    plus: '성장주',
    minus: '가치주',
    plus_info: '는 현재 실적보다 미래 성장이 큰 기업을 의미합니다.',
    minus_info: '는 기업가치에 비해 저평가된 기업을 의미합니다.'
  },
  'RLTV04': {
    value: 'RLTV04',
    label: '산업',
    plus: '첨단산업',
    minus: '전통산업',
    plus_info: '은 IT, 바이오, 신기술 산업 등을 의미합니다.',
    minus_info: '은 산업재, 중공업 등 굴뚝 산업을 의미합니다.'
  },
  'RLTV03': {
    value: 'RLTV03',
    label: '대상',
    plus: '중소형주',
    minus: '대형주',
    plus_info: '는 시가총액이 1,000~3,000위 기업을 의미합니다.',
    minus_info: '는 시가총액이 500위 이내 기업을 의미합니다.'
  }
}

export const PROMISING_INDUSTRY_MENU = [
  {
    value: 'XLK',
    label: 'IT/테크'
  },
  {
    value: 'XLF',
    label: '금융'
  },
  {
    value: 'XLV',
    label: '헬스케어'
  },
  {
    value: 'XLY',
    label: '경기소비재'
  },
  {
    value: 'XLC',
    label: '통신서비스'
  },
  {
    value: 'XLI',
    label: '산업재'
  },
  {
    value: 'XLP',
    label: '필수소비재',
  },
  {
    value: 'XLE',
    label: '에너지'
  },
  {
    value: 'XLRE',
    label: '리츠/부동산'
  },
  {
    value: 'XLB',
    label: '소재'
  }
]

export const PROMISING_INDUSTRY_GUBN = {
  'XLK': {
    value: 'XLK',
    label: 'IT/테크'
  },
  'XLF': {
    value: 'XLF',
    label: '금융'
  },
  'XLV': {
    value: 'XLV',
    label: '헬스케어'
  },
  'XLY': {
    value: 'XLY',
    label: '경기소비재'
  },
  'XLC': {
    value: 'XLC',
    label: '통신서비스'
  },
  'XLI': {
    value: 'XLI',
    label: '산업재'
  },
  'XLP': {
    value: 'XLP',
    label: '필수소비재',
  },
  'XLE': {
    value: 'XLE',
    label: '에너지'
  },
  'XLRE':{
    value: 'XLRE',
    label: '리츠/부동산'
  },
  'XLB':{
    value: 'XLB',
    label: '소재'
  }
}
